import { render } from "./AutoShipWithdrawal.vue?vue&type=template&id=99f1fbc4"
import script from "./AutoShipWithdrawal.vue?vue&type=script&lang=js"
export * from "./AutoShipWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__